import { type FC, useEffect, useState } from 'react';
import { motion } from 'framer-motion';

interface HandPointerProps {
  className?: string;
  style?: React.CSSProperties;
  animateOpacity?: boolean;
}

export const HandPointer: FC<HandPointerProps> = ({
  className,
  style,
  animateOpacity = false,
}) => {
  const [showPulse, setShowPulse] = useState(false);
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setShowPulse(true);
      setTimeout(() => setShowPulse(false), 600);
    }, 2000);

    return (): void => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!animateOpacity) return;

    let interval: ReturnType<typeof setInterval>;

    const timeout = setTimeout(() => {
      setOpacity(0);
      interval = setInterval(() => {
        setOpacity((prev) => (prev === 1 ? 0 : 1));
      }, 3000);
    }, 4500);

    return (): void => {
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, [animateOpacity]);

  return (
    <div
      className={`absolute ${className}`}
      style={{
        ...style,
        opacity: animateOpacity ? opacity : style?.opacity,
        transition: 'opacity 0.3s ease-in-out',
      }}
    >
      <motion.img
        src="/img/icons/touch.png"
        alt=""
        initial={{ y: -10 }}
        animate={{ y: [-10, 0, -10] }}
        transition={{
          delay: 0.5,
          duration: 2,
          repeat: Infinity,
          ease: 'easeOut',
          onComplete: () => setShowPulse(true),
        }}
      />

      {showPulse && (
        <div className="absolute left-[45%] top-0 -translate-x-1/2 -translate-y-1/2 pointer-events-none z-10">
          <motion.div
            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full pointer-events-none z-10"
            initial={{
              width: 24,
              height: 24,
              backgroundColor: '#FFFFFF33',
              opacity: 1,
            }}
            animate={{
              width: 40,
              height: 40,
              opacity: 0,
            }}
            transition={{
              duration: 0.6,
              ease: 'easeOut',
            }}
          />
          <motion.div
            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full pointer-events-none z-10"
            initial={{
              width: 20,
              height: 20,
              backgroundColor: '#FFFFFF33',
              opacity: 1,
            }}
            animate={{
              width: 24,
              height: 24,
              opacity: 0,
            }}
            transition={{
              duration: 0.6,
              ease: 'easeOut',
            }}
          />
        </div>
      )}
    </div>
  );
};
